import SessionChart from './SessionChart';

export default SessionChart;
